<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         
        <w-form >
              <w-flex class="mt3">
                <div class="xs4 mr3">
                       <w-input
                       type="date"
                        label="Tarikh Fail"
                        name="tarikh_fail"
                        v-model="cari.tarikh_fail">
                       </w-input>
                    </div>
                <div class="xs4 mr3">
                       <w-input
                        
                        label="No Resit"
                        name="no_resit"
                        v-model="cari.no_resit">
                       </w-input>
                    </div>
                <div class="xs4 mr3">
                       <w-input
                        
                        label="TID"
                        name="tid"
                        v-model="cari.tid">
                       </w-input>
                    </div>
                     <div class="xs4 mr3" style="margin-top: -5px">
                    <w-select class="mt4"  :items="status_proses"   v-model="cari.status_proses" placeholder="Status Proses"  /> 
                  </div>
                    
              </w-flex>
              
            </w-form>

            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>


            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>        

        <z-page title="Penyata Penyesuian" class="mt3">
            
             <z-table ref="tbluser" title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">

                    
                       <inertia-link :href='$route("fail_mdr.show",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                  </w-flex>
                </template>
                
            </z-table>
        </z-page>
          <w-overlay
              v-model="showOverlay"
              :persistent= true>
              
            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            </w-overlay>


    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    //  
  },
  data() {
    return {
        resourceurl: this.service_penyata+'fail_mdr',
        reload: true,
        showOverlay: false,
        loading : false,
        crumbs: [
              // { label: this.$page.props.app_name, route: '/sitemap' },
          { label: 'iHasil', route: '/' },
          { label: 'Penyata Penyesuian', route: '/fail_mdr' },
        ],
        status_proses :[
          {value : 1, label : 'BELUM PROSES'},
          {value : 2, label : 'SEDANG PROSES'},
          {value : 3, label : 'SELESAI'}
        ],
        form: {
          // id: 0,
          no: '',
          no_dokumen: '', 
          showOverlay: false, 
          loading : false,
          },
         cari : {tarikh_fail: '', no_resit : '', tid : '', status_proses : ''}
    }
       
  },
  methods: {

    search() {
            // this.cari.loading = true
             this.loading = true
            this.showOverlay= true
            var url = window.route('fail_mdr.index')+'?tarikh_fail='+this.cari.tarikh_fail+'&no_resit='+this.cari.no_resit+'&tid='+this.cari.tid+'&status_proses='+this.cari.status_proses;
            this.$inertia.visit(url, { preserveScroll : true})

          },
          reset(){
            this.cari = {tarikh_fail: '', no_resit : '', tid : '', status_pos : '', lkp_bayaran_status_id : ''}
            var url = window.route('fail_mdr.index')+'?tarikh_fail='+this.cari.tarikh_fail+'&no_resit='+this.cari.no_resit+'&tid='+this.cari.tid+'&status_proses='+this.cari.status_proses;
            this.$inertia.visit(url, { preserveScroll : true})
          },
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500

    // this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    // if(this.cari.no_bayaran == 'undefined'){this.cari.no_bayaran = ''}
    // if(this.cari.profil == 'undefined'){this.cari.profil = ''}
    // if(this.cari.tarikh == 'undefined'){this.cari.tarikh = ''}
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>